// ............................... Function ProfiledetailsLoading ................................
export function ProfiledetailsLoading() {
  return (
    <div className="animate-pulse space-y-4 p-4">
      <div className="rounded-full bg-gray-300 w-20 h-20 mx-auto"></div>
      <div className="h-4 bg-gray-300 rounded w-3/4 mx-auto"></div>
      <div className="h-1 bg-gray-300 rounded w-25 mx-auto"></div>
      <div className="h-8 bg-gray-300 rounded w-40 mx-auto mt-6"></div>
      <div className="h-8 bg-gray-300 rounded-[50px] w-25 mx-auto mt-6"></div>
    </div>
  );
}

// ............................... Function LoadingSkeleton ................................
export function LoadingSkeleton({
  itemCount = 3,
  avatarSize = 10,
  textWidth = 32,
}) {
  return (
    <div>
      {[...Array(itemCount)].map((_, i) => (
        <div
          key={i}
          className="flex items-center justify-between animate-pulse space-x-7 mb-4 border-b border-gray-300 pb-4 last:border-b-0 last:pb-0"
        >
          {/* Avatar Section */}
          <div className="flex items-center gap-3">
            <div
              className={`rounded-full bg-gray-300 w-${avatarSize} h-${avatarSize}`}
            ></div>
            {/* Text Section */}
            <div className="space-y-2">
              <div className={`h-3 bg-gray-300 rounded w-${textWidth}`}></div>
              <div
                className={`h-3 bg-gray-300 rounded w-${textWidth - 8}`}
              ></div>
            </div>
          </div>
          {/* Additional Item Placeholder */}
          <div className="h-3 bg-gray-300 rounded w-16"></div>
        </div>
      ))}
    </div>
  );
}

// ............................... Function PersonalInfoLoading ................................
export function PersonalInfoLoading() {
  return (
    <div className="space-y-6">
      <LoadingSkeleton itemCount={3} avatarSize={12} textWidth={40} />
    </div>
  );
}

// ............................... Function CompanyInfoLoading component using LoadingSkeleton ................................
export function LoadingCompanySkeleton({
  itemCount = 3,
  avatarSize = 10,
  textWidth = 32,
}) {
  return (
    <div>
      {[...Array(itemCount)].map((_, i) => (
        <div
          key={i}
          className="flex items-center justify-between animate-pulse space-x-7 mb-4 border-b border-gray-300 pb-4 last:border-b-0 last:pb-0"
        >
          {/* Avatar Section */}
          <div className="flex items-center gap-3">
            <div
              className={`rounded-full bg-gray-300 w-${avatarSize} h-${avatarSize}`}
            ></div>
            {/* Text Section */}
            <div className="space-y-2">
              <div className={`h-3 bg-gray-300 rounded w-${textWidth}`}></div>
              <div
                className={`h-3 bg-gray-300 rounded w-${textWidth - 8}`}
              ></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

// ............................... Function CompanyInfoLoading ................................
export function CompanyInfoLoading() {
  return (
    <div className="space-y-6">
      <LoadingCompanySkeleton itemCount={6} avatarSize={12} textWidth={40} />
    </div>
  );
}

// ............................... Function CompanyInfoLoading component using LoadingSkeleton ................................
export function LoadingSettingSkeleton({
  itemCount = 3,
  avatarSize = 10,
  textWidth = 32,
}) {
  return (
    <div>
      {[...Array(itemCount)].map((_, i) => (
        <div
          key={i}
          className="flex items-center justify-between animate-pulse space-x-7 mb-4 border-b border-gray-300 pb-4 last:border-b-0 last:pb-0"
        >
          {/* Avatar Section */}
          <div className="flex items-center gap-3">
            <div
              className={`rounded-full bg-gray-300 w-${avatarSize} h-${avatarSize}`}
            ></div>
            {/* Text Section */}
            <div className="space-y-2">
              <div className={`h-4 bg-gray-300 rounded w-${textWidth}`}></div>
            </div>
          </div>
          {/* Additional Item Placeholder */}
          <div className="h-2 bg-gray-300 rounded w-4"></div>
        </div>
      ))}
    </div>
  );
}

// ............................... Function SettingInfoLoading ................................
export function SettingInfoLoading() {
  return (
    <div className="space-y-6">
      <LoadingSettingSkeleton itemCount={3} avatarSize={12} textWidth={40} />
    </div>
  );
}

// ............................... Function BalancecontentSkeleton ................................
export function BalancecontentSkeleton({ itemCount = 1, textWidth = 32 }) {
  return (
    <div className="w-full">
      {[...Array(itemCount)].map((_, i) => (
        <div
          key={i}
          className="relative w-full flex justify-between items-start px-1.5 py-4 text-white rounded-lg shadow-md
             bg-[linear-gradient(89.99deg,rgba(255,255,255,0.175)-72.99%,rgba(255,255,255,0.35)100%)]"
        >
          {/* Left Section */}
          <div className="flex flex-col space-y-6">
            {/* Label Placeholder */}
            <div className="h-3 w-40 bg-white/20 rounded animate-pulse"></div>

            {/* Currency + Amount */}
            <div className="flex items-end gap-2">
              <div className="h-5 w-10 bg-white/20 rounded animate-pulse"></div>
              <div
                className="h-8 bg-white/30 rounded animate-pulse"
                style={{ width: `${textWidth * 7}px` }}
              ></div>
            </div>
          </div>

          {/* Right Section */}
          <div className="flex flex-col items-end space-y-4">
            {/* Last updated placeholder */}
            <div className="h-4 w-44 bg-white/20 rounded animate-pulse"></div>

            {/* Country Selector placeholder */}
            <div className="flex items-center gap-2 mt-3">
              <div className="h-5 w-6 bg-white/20 rounded-full animate-pulse"></div>
              <div className="h-5 w-14 bg-white/20 rounded animate-pulse"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

// ............................... Function BalancecontentLoading ................................
export function BalancecontentLoading() {
  return (
    <div className="space-y-6 w-full">
      <BalancecontentSkeleton itemCount={1} textWidth={40} />
    </div>
  );
}
